import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IStatistic2ReportParameter } from '@fi-app/statistic2/statistic2';
import { NgModel } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';
import { Statistic2ReportParameterEditComponent } from '@fi-app/statistic2/statistic2-report-parameter-edit/statistic2-report-parameter-edit/statistic2-report-parameter-edit.component';
import { Statistic2Service } from '@fi-app/statistic2/statistic2.service';
import { BehaviorSubject } from 'rxjs';
import { AccessRightFilterCollectionModel, ILightWeightObject } from '@fi-shared/models';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-statistic2-report-parameter-edit-dialog',
    template: `
        @if (!(loaded$ | async)) {
          <fi-loading></fi-loading>
        }
        @if (loaded$ | async) {
          <fi-statistic2-report-parameter-edit
            [(ngModel)]="data"
            (ngModelChange)="onReportParameterChanged()"
            [currentPage]="currentPage"
            [accessRightFilterCollection]="accessRightFilterCollection"
            [availableDocumentTags]="documentTags"
            [availableDocuments]="documents"
            [availableMediaBankFileTags]="mediaBankFileTags"
            [availableMediaBankFiles]="mediaBankFiles"
            #reportParameterModel="ngModel"
          ></fi-statistic2-report-parameter-edit>
        }
        `,
    styleUrls: ['./statistic2-report-parameter-edit-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-statistic2-report-parameter-edit-dialog' },
    standalone: false,
})
export class Statistic2ReportParameterEditDialogComponent
    extends FiDialogsContentBase<IStatistic2ReportParameter, IStatistic2ReportParameter>
    implements OnInit
{
    @ViewChild('reportParameterModel', { static: false }) reportParameterModel: NgModel;
    @ViewChild(Statistic2ReportParameterEditComponent, { static: false })
    reportEditComponent: Statistic2ReportParameterEditComponent;

    loaded$ = new BehaviorSubject(false);
    currentPage = 1;
    accessRightFilterCollection: AccessRightFilterCollectionModel;

    documentTags: ILightWeightObject[];
    documents: ILightWeightObject[];

    mediaBankFileTags: ILightWeightObject[];
    mediaBankFiles: ILightWeightObject[];

    private appTextService: AppTextService;
    private yesButtonDisabled = false;

    ngOnInit() {
        this.appTextService = this.injector.get(AppTextService);
        this.injector
            .get(Statistic2Service)
            .getDataForReportParameterSettings()
            .then(
                (data) => {
                    this.accessRightFilterCollection = data.AccessRights;

                    this.documents = data.Documents;
                    this.documentTags = data.DocumentTags;

                    this.mediaBankFiles = data.MediaBankFiles;
                    this.mediaBankFileTags = data.MediaBankFileTags;

                    this.loaded$.next(true);
                },
                () => this.dialogRef.close(),
            );
    }

    private updateYesButtonDisabled() {
        this.yesButtonDisabled = this.reportParameterModel && this.reportParameterModel.invalid;
    }
    isYesButtonDisabled() {
        return this.yesButtonDisabled;
    }
    onReportParameterChanged() {
        this.updateYesButtonDisabled();
    }

    getNoButtonText() {
        return this.appTextService.get(this.currentPage === 2 ? 'back' : 'common.cancel').toUpperCase();
    }

    getYesButtonText() {
        const yesButtonTextId = (() => {
            if (this.currentPage === 1) return 'common.next';
            if (this.data.Id) {
                return 'common.save_changes';
            }
            return 'statistic.create_report';
        })();

        return this.appTextService.get(yesButtonTextId).toUpperCase();
    }

    onNoButtonClick($event: MouseEvent) {
        if (this.currentPage === 2) {
            $event.preventDefault();
            this.currentPage--;
        }
    }

    onYesButtonClick($event: MouseEvent) {
        if (this.currentPage === 1) {
            $event.preventDefault();
            this.currentPage++;
        }
    }

    getResult() {
        if (!this.data.Name) {
            this.data.Name = this.reportEditComponent.getDefaultReportName();
        }
        return this.data;
    }
}
